import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const PluginListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"overview"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PluginListings","document":PluginListingsDocument}} as const;
export type PluginListingsQueryVariables = Types.Exact<{
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type PluginListingsQuery = (
  { __typename: 'Query' }
  & { plugin?: Types.Maybe<(
    { __typename: 'Plugin' }
    & Pick<Types.Plugin, 'id'>
    & { listings?: Types.Maybe<Array<(
      { __typename: 'Plugin_Listings' }
      & Pick<Types.Plugin_Listings, 'id' | 'description' | 'locale' | 'name' | 'overview'>
    )>> }
  )> }
);

/**
 * __usePluginListingsQuery__
 *
 * To run a query within a React component, call `usePluginListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginListingsQuery({
 *   variables: {
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function usePluginListingsQuery(
  baseOptions: TrelloQueryHookOptions<
    PluginListingsQuery,
    PluginListingsQueryVariables
  > &
    (
      | { variables: PluginListingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PluginListingsDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PluginListingsQuery,
    PluginListingsQueryVariables
  >(PluginListingsDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePluginListingsLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PluginListingsQuery,
    PluginListingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PluginListingsQuery, PluginListingsQueryVariables>(
    PluginListingsDocument,
    options,
  );
}
export function usePluginListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        PluginListingsQuery,
        PluginListingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PluginListingsQuery,
    PluginListingsQueryVariables
  >(PluginListingsDocument, options);
}
export type PluginListingsQueryHookResult = ReturnType<
  typeof usePluginListingsQuery
>;
export type PluginListingsLazyQueryHookResult = ReturnType<
  typeof usePluginListingsLazyQuery
>;
export type PluginListingsSuspenseQueryHookResult = ReturnType<
  typeof usePluginListingsSuspenseQuery
>;
export type PluginListingsQueryResult = Apollo.QueryResult<
  PluginListingsQuery,
  PluginListingsQueryVariables
>;
